import { Uuid } from "@formant/core/model/Uuid";

import { rtcSignalingStore, signalingStore } from "../stores";

export function deviceIsTeleopable(id: Uuid): boolean {
    return !!(
        rtcSignalingStore
            .peerDevices({
                onlyTeleopable: true,
            })
            ?.find(_ => _.id === id) ||
        signalingStore.peerDevices()?.find(_ => _.id === id)
    );
}
